import axios from "./configs/axiosConfig";

export const verifyDealer = async (id) => {
  const url = `/dealer/${id}/verify`;
  return await axios.get(url);
};

export const checkDealerOnboard = async (id) => {
  const url = `/dealer/${id}/onboard`;
  return await axios.get(url);
};

export const updateDealerRegisterStatus = async (id) => {
  const url = `/dealer/${id}`;
  return await axios.patch(url);
};

export const createNewOnboarding = async (newOnboarding) => {
  const url = `newdealeronboard`;
  return await axios.post(url, newOnboarding);
};

export const getNonOnboardedDealers = async () => {
  const url = `/dealer/nononboardedlist`;
  return await axios.get(url);
};
export const getlatestOnboardedDealers = async () => {
  const url = `/dealer/latestonboardeddealers`;
  return await axios.get(url);
};

export const getDealerDetailsCardData = async (id) => {
  const url = `/dealer/${id}/cardsdata`;
  return await axios.get(url);
};

export const getTransmissionDetailsByDealer = async (id) => {
  const url = `/dealer/${id}/transmissiondetails`;
  return await axios.get(url);
};
export const getTransmissionDetailsHistoryByDealer = async (id) => {
  const url = `/dealer/${id}/transmissiondetailshistory`;
  return await axios.get(url);
};

export const getTenantInfo = async (id,crmType) => {
  let url = `/dealer/${id}/gettenantinfo`;
  if (crmType === "Workiz"){
    url = `/dealer/${id}/getworkizinfo`;
  }
  return await axios.get(url);
};

export const getAllDealers = async (key,type) => {
  const url = `/dealer?key=${key}&&type=${type}`;
  return await axios.get(url);
};


export const dealerAdminToolsUpdate = async (id,action,userId,value,crmSystem,tenantId) => {
  const url = `/dealer/${id}/admtools?action=${action}&&uid=${userId}&&value=${value}&&crmsystem=${crmSystem}&&tenantid=${tenantId}`;
  return await axios.put(url);
};

export const dealerVerifyAdminTools = async (id) => {
  const url = `/dealer/${id}/admtools/dealerverify`;
  return await axios.get(url);
};

export const getAgreementsByDealerIdAndLocatonId = async (dealerId , locationId) => {
  const url = `/dealer/${dealerId}/location/${locationId}`;
  return await axios.get(url);
};

export const createNewDealer = async (dealer) => {
  const url = `dealer`;
  return await axios.post(url, dealer);
}
export const getDealersPendingList = async () => {
  const url = `/dealer/pendinglist`;
  return await axios.get(url);
};